import "./layout-web.scss";
import { Navbar } from "../../components";
import useViewport from "../../hooks/useViewport";
import WebManagementNavbar from "../../components/WebManagementNavbar/WebManagementNavbar";
import WebManagementNavbarNew from "../Web/WebManagementNavBarNew";

const LayoutWeb = ({ children, subTitle }) => {
  useViewport();

  return (
    <div className="LayoutWeb">
      <Navbar title={subTitle} />
      <div className="LayoutWeb__contain">
        {window.location.pathname === "/webhomepage" ||
        window.location.pathname === "/catalogos" ||
        window.location.pathname === "/servicios" ||
        window.location.pathname === "/contacto" ? (
          <WebManagementNavbar />
        ) : (
          <WebManagementNavbarNew />
        )}

        <div className="LayoutWeb__contain__children">{children}</div>
      </div>
    </div>
  );
};

export default LayoutWeb;
